import { Card } from "@boundary/components/card";
import { PlusFilledIcon } from "@boundary/components/icons";
import styles from "./addServiceCard.module.scss";

interface AddServiceCardProps {
  onClick: () => void;
}

export function AddServiceCard({ onClick }: AddServiceCardProps) {
  return (
    <Card
      asChild
      state="selected"
      size="square"
      className={styles.card}
    >
      <button 
        onClick={() => {
          console.log(`[Button Click] AddServiceCard: "Добавить ещё услугу"`);
          onClick();
        }}
      >
        <span className={styles.title}>Добавить ещё услугу</span>
        <PlusFilledIcon size={36} className={styles.icon} />
      </button>
    </Card>
  );
}

